// message model repository

import http from '../services/http'
import auth from '../services/auth'

const BASE_ROUTE = '/marker'

export default {
  // retrieve the push notification delivery status for a marker
  fetchMarkerMessages: function (markerId) {
    return http.get(`${BASE_ROUTE}/${markerId}/message/`, auth.getAuthHeader(), undefined, true)
  },

  fetchServiceMessages () {
    return http.get(`/mp/service_messages/`, auth.getAuthHeader())
  },
}
